<ng-template #template let-row="row">
  <button mat-button data-test="column-remarks__remarks-button" class="button--text" (click)="openRemarksDialog(row)">
    <mat-icon>insert_comment</mat-icon>
  </button>
</ng-template>
